export const PlayerInfo = ({ positions }: { positions: string[] }) => (
  <div className="flex gap-x-3 p-2 h-full">
    <div className="text-sm my-auto large:text-base ">
      {positions.map((p) => `${p}`).join(", ")}
    </div>
  </div>
);
